import {
  HStack,
  Icon,
  IconButton,
  Popover,
  PopoverProps,
  PopoverTrigger,
  Stack,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { RiNotification2Line } from "@remixicon/react";
import { useEffect } from "react";
import { useGetUserLoginStore } from "../../store/useGetUserLoginStore";
import { useUserHeader } from "../../store/useUserHeader";
import { PopoverNotification } from "./PopoverNotification";

interface Props extends PopoverProps {}

export const PopoverHeaderNotification = ({ ...rest }: Props) => {
  const { notificationCount, fetchNotificationCount } = useUserHeader();
  const { currentActiveUser } = useGetUserLoginStore();
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    fetchNotificationCount();
  }, [fetchNotificationCount]);

  return (
    <Popover
      trigger={"hover"}
      placement="bottom"
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      {...rest}
    >
      <PopoverTrigger>
        {notificationCount === 0 ? (
          <IconButton
            icon={<Icon as={RiNotification2Line} fontSize={"2xl"} />}
            variant={"ghost"}
            size={"md"}
            aria-label={"Toggle Navigation"}
          />
        ) : (
          <HStack cursor={"pointer"}>
            <Icon as={RiNotification2Line} fontSize={"2xl"} />

            <Stack
              bg={"secondary"}
              rounded={"full"}
              mt={"-20px"}
              ml={"-20px"}
              h={"18px"}
              w={"18px"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <Text color={"white"} fontWeight={"bold"} fontSize={"8px"}>
                {notificationCount}
              </Text>
            </Stack>
          </HStack>
        )}
      </PopoverTrigger>

      <PopoverNotification
        isOpen={isOpen}
        currentActiveUser={currentActiveUser}
      />
    </Popover>
  );
};
